/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function DiffAdded({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 15" {...props}><path fill="currentColor" d="M7.1 3a.6.6 0 0 1 .6.6v2.9h2.9a.6.6 0 1 1 0 1.2H7.7v2.9a.6.6 0 1 1-1.2 0V7.7H3.6a.6.6 0 0 1 0-1.2h2.9V3.6a.6.6 0 0 1 .6-.6Z" /><path fill="currentColor" fillRule="evenodd" d="M0 2.6A2.6 2.6 0 0 1 2.6 0h9a2.6 2.6 0 0 1 2.6 2.6v9a2.6 2.6 0 0 1-2.6 2.6h-9A2.6 2.6 0 0 1 0 11.6v-9Zm2.6-1.4a1.4 1.4 0 0 0-1.4 1.4v9A1.4 1.4 0 0 0 2.6 13h9a1.4 1.4 0 0 0 1.4-1.4v-9a1.4 1.4 0 0 0-1.4-1.4h-9Z" clipRule="evenodd" /></svg>;
}
;